"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var InputSwitch = /*#__PURE__*/function (_React$Component) {
  _inherits(InputSwitch, _React$Component);

  function InputSwitch(props) {
    _classCallCheck(this, InputSwitch);

    return _possibleConstructorReturn(this, (InputSwitch.__proto__ || Object.getPrototypeOf(InputSwitch)).call(this, props));
  }

  _createClass(InputSwitch, [{
    key: "render",
    value: function render() {
      var _this = this;

      var hasError = this.props.errors ? this.props.errors[this.props.name] : false,
          inputClasses = 'btn-group-switch',
          error;

      if (hasError) {
        error = this.props.errors[this.props.name].map(function (errorMsg) {
          return _this.props.t(errorMsg);
        }).join(', ');
        inputClasses += ' ' + 'error';
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: inputClasses
      }, /*#__PURE__*/_react.default.createElement("label", null, this.props.label), this.props.buttons.map(function (entry, key) {
        return /*#__PURE__*/_react.default.createElement("button", {
          key: key,
          name: _this.props.name,
          onClick: function onClick(e) {
            return _this.props.onChange(e, key);
          },
          className: key === _this.props.selectedIndex ? 'button-switch switch-selected' : 'button-switch'
        }, entry.title);
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: 'error-message'
      }, hasError ? error : ''));
    }
  }]);

  return InputSwitch;
}(_react.default.Component);

InputSwitch.propTypes = {
  label: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  buttons: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string.isRequired
  })).isRequired,
  onChange: _propTypes.default.func.isRequired,
  selectedIndex: _propTypes.default.number,
  errors: _propTypes.default.object,
  t: _propTypes.default.any
};
var _default = InputSwitch;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/form-inputs/input-switch.js
// module id = 542
// module chunks = 0